/**
 * Parse URL parameters from the current URL
 * @returns {Object} Object containing parsed URL parameters
 */
export const parseUrlParams = () => {
  const params = new URLSearchParams(window.location.search);
  
  const result = {
    language: params.get('lang'),
    type: params.get('type'),
    petType: params.get('petType'),
    petName: params.get('petName')
  };
  
  // Parse date if present
  const dateString = params.get('date');
  if (dateString) {
    const [year, month, day] = dateString.split('-').map(num => parseInt(num, 10));
    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      // Month in JavaScript is 0-based, so subtract 1
      result.date = new Date(year, month - 1, day);
    }
  }
  
  return result;
};

/**
 * Generate a SEO-friendly URL for sharing
 * @param {Object} params Parameters for generating the URL
 * @returns {string} SEO-friendly URL
 */
export const generateSEOFriendlyURL = ({ anniversaryDate, anniversaryType, petType, petName, language }) => {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  
  // Add date in YYYY-MM-DD format
  const formattedDate = `${anniversaryDate.getFullYear()}-${String(anniversaryDate.getMonth() + 1).padStart(2, '0')}-${String(anniversaryDate.getDate()).padStart(2, '0')}`;
  params.set('date', formattedDate);
  
  // Add anniversary type
  params.set('type', anniversaryType);
  
  // Add pet type if available
  if (petType) {
    params.set('petType', petType);
  }
  
  // Add pet name if available
  if (petName) {
    params.set('petName', petName);
  }
  
  // Add language
  params.set('lang', language);
  
  return url.toString();
};